import { graphqlPost } from "api/graphqlClient";
import NotificationService from "components/Notification/Notification.service";
import { actions as workspacesActions } from "containers/Workspaces/Workspaces.reducer";
import { call, put, takeLatest } from "redux-saga/effects";

/**
 * Fetch Workspace
 * @param  {Object} promise
 * @param {string} id Workspace ID
 * @return {Object} response from API
 */
export function* fetchSingleWorkspace({ promise, id, params }) {
    try {
        const fetchSingleWorkspaceAPI = yield graphqlPost(params);
        yield put({
            type: workspacesActions.FETCH_WORKSPACE_SUCCESSFUL,
        });
        yield put({
            type: workspacesActions.STORE_WORKSPACE_DATA,
            iri: id,
            response: fetchSingleWorkspaceAPI?.data?.workspace,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield put({
            type: workspacesActions.FETCH_WORKSPACE_FAILED,
        });
        NotificationService.error(error?.response?.data || error); // TODO (medium) should use <RestErrorNotification> here, but leads to unexpected webpack error
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Register action to watcher
 */
export default [
    takeLatest(workspacesActions.START_FETCHING_WORKSPACE, fetchSingleWorkspace),
];
